import ReviewDecisionPanel from "./ReviewDecisionPanel";
import { getCurrentStageIds } from "../../utils/currentStage";

export default function StageReviewTab({
  project,
  stageDef,
  activeAssignments,
  outgoingConnections,
  isTerminalStage,
  onReview,
  loading,
}) {
  const primaryAssignment = (activeAssignments || [])[0] || null;

  if (!primaryAssignment) return null;

  return (
    <div className="stage-review-tab">
      <ReviewDecisionPanel
        assignment={primaryAssignment}
        stageDef={stageDef}
        workflowDefinition={project?.workflow?.definition}
        currentStageIds={getCurrentStageIds(project)}
        outgoingConnections={outgoingConnections}
        projectHistory={project?.stageAssignments || []}
        onSubmit={onReview}
        onClose={() => {}}
        disabled={loading}
        isTerminalStage={isTerminalStage}
      />
    </div>
  );
}
